import { ApiConfig, Variables } from '@common/types/api'
import { normalizeCollection, normalizeProduct } from '@framework/utils'
import { Collection as ShopifyCollection } from '@framework/schema'
import getCollectionQuery from '@framework/utils/queries/get-collection'
import { Collection } from '@common/types/collection'
import { Pagination } from '@common/types/pagination'
import { Metafields } from '@framework/types/metafields'

type FetchType = {
  collectionByHandle: ShopifyCollection
}

type ReturnType = {
  collection: Collection | null
  productPagination: Pagination
}

const getCollection = async (options: {
  config: ApiConfig
  variables: Variables
}): Promise<ReturnType> => {
  const { config, variables } = options

  const { data } = await config.fetch<FetchType>({
    query: getCollectionQuery,
    variables,
  })

  const { collectionByHandle } = data

  return {
    collection: collectionByHandle
      ? normalizeCollection(
          collectionByHandle as ShopifyCollection & Metafields
        )
      : null,
    productPagination: {
      endCursor: collectionByHandle.products.pageInfo.endCursor ?? '',
      hasNextPage: collectionByHandle.products.pageInfo.hasNextPage ?? false,
    },
  }
}

export default getCollection
